import {
  Box,
  Flex,
  Input,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import { getAbsentStudentsRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAllLecturesRequest } from "../../../modules/admin-modules/lectures/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";

const AbsentReport = () => {
  const dispatch = useDispatch();
  const [lecId, setLecId] = useState("");
  const [groupId, setGroupId] = useState("");
  const [lectureDate, setLectureDate] = useState(dayjs().format("YYYY-MM-DD"));

  useEffect(() => {
    dispatch(getAllLecturesRequest());
    dispatch(getAllGroupsRequest());
  }, []);

  useEffect(() => {
    if (lecId && groupId && lectureDate) {
      dispatch(
        getAbsentStudentsRequest({
          lec_id: lecId,
          group_id: groupId,
          lecture_date: lectureDate,
        })
      );
    }
  }, [lecId, groupId, lectureDate]);

  const lectures = useSelector((state) => state.lectures.lectures);
  const groups = useSelector((state) => state.groups.groups);
  const absentStudents = useSelector((state) => state.reports.absentStudents);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const lectureOptions = lectures?.map((data) => ({
    value: data.id,
    label: data.title,
  }));

  const groupOptions = groups?.map((data) => ({
    value: data.id,
    label: data.name,
  }));

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const headers = [
    { label: "name", key: "name" },
    { label: "user_name", key: "user_name" },
    { label: "phone", key: "phone" },
    { label: "parent_phone", key: "parent_phone" },
  ];

  const list = Array.isArray(absentStudents) ? absentStudents : [];
  const Data = list.map((data, index) => ({
    ...data,
    index: `#${index + 1}`,
    id: data?.id,
    name: data?.name,
    user_name: data?.user_name,
    parent_phone: data?.parent_phone,
    phone: data?.phone,
  }));

  // CSV data with phone columns as text (tab prefix) so Excel doesn't show scientific notation
  const csvData = Data.map((row) => ({
    ...row,
    phone: row.phone != null ? `\t${String(row.phone)}` : "",
    parent_phone: row.parent_phone != null ? `\t${String(row.parent_phone)}` : "",
  }));

  const columns = [
    { Header: "رقم الطالب", accessor: "index" },
    { Header: "اسم الطالب", accessor: "name" },
    { Header: "اسم المستخدم", accessor: "user_name" },
    { Header: "رقم هاتف ولي الامر", accessor: "parent_phone" },
    { Header: "رقم هاتف الطالب", accessor: "phone" },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
          flexWrap="wrap"
          gap="4"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير الغياب
          </Text>
          <Flex
            w={{ base: "100%", md: "auto" }}
            flexDirection={{ base: "column", md: "row" }}
            alignItems={{ base: "stretch", md: "center" }}
            gap="3"
          >
            <Box w={{ base: "100%", md: "200px" }}>
              <Select
                options={lectureOptions}
                isMulti={false}
                onChange={(data) => setLecId(data?.value ?? "")}
                styles={colourStyles}
                placeholder="اختر السنتر"
              />
            </Box>
            <Box w={{ base: "100%", md: "200px" }}>
              <Select
                options={groupOptions}
                isMulti={false}
                onChange={(data) => setGroupId(data?.value ?? "")}
                styles={colourStyles}
                placeholder="اختر المجموعة"
              />
            </Box>
            <Box w={{ base: "100%", md: "200px" }}>
              <Input
                type="date"
                value={lectureDate}
                onChange={(e) => setLectureDate(e.target.value)}
                bg="gray.100"
                borderRadius="16px"
                border="1px solid"
                borderColor="gray.200"
              />
            </Box>
            <Box
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
              alignSelf="center"
            >
              <CSVLink
                headers={headers}
                data={csvData?.length ? csvData : []}
                filename={"absent-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={() => {}}
          Columns={columns}
          Data={Data}
          path="openModel"
          Actions
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil((Data?.length || 0) / size) || 1}
        />
      </div>
    </Layout>
  );
};

export default AbsentReport;
